import { styled, css } from 'styled-components';

export const Container = styled.div<{ $isDragging: boolean }>`
  ${({ $isDragging }) => css`
    display: flex;
    opacity: ${$isDragging ? 0.5 : 1};
    place-self: flex-start;
    width: 100%;

    @media print {
      transform: scale(0.94);
    }
  `}
`;
